import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons';
import { GoldLoader } from '../shared/Loaders';

const ParticipantGuestRow = ({ participantId, onOpenGuest }) => {
  const API_URL = process.env.REACT_APP_API_URL || '';
  const [guests, setGuests] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchGuests = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(`${API_URL}/ems/participants/${participantId}/guests`);
      setGuests(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      setError(err?.response?.data?.message || 'Failed to load guests');
    } finally {
      setLoading(false);
    }
  }, [API_URL, participantId]);

  useEffect(() => {
    fetchGuests();
  }, [fetchGuests]);

  return (
    <div className="participant-guest-panel-wrap">
      <div className="participant-guest-panel">
      {loading ? (
        <div style={{ padding: '12px 24px' }}>
          <GoldLoader label="Loading..." variant="inline" />
        </div>
      ) : error ? (
        <div className="text-danger small" style={{ padding: '12px 24px' }}>{error}</div>
      ) : !guests || guests.length === 0 ? (
        <div style={{ color: '#888', fontStyle: 'italic', fontSize: '13px', padding: '12px 24px' }}>
          No guests
        </div>
      ) : (
        <>
          <div className="participant-guest-header">
            <div>Last Name</div>
            <div>First Name</div>
            <div>Email</div>
            <div style={{ textAlign: 'center' }}>Action</div>
          </div>
          {guests.map((g) => (
            <div className="participant-guest-row" key={g._id}>
              <div>{g.lastName || '—'}</div>
              <div>{g.firstName || '—'}</div>
              <div>{g.email || '—'}</div>
              <div style={{ textAlign: 'center' }}>
                <button
                  type="button"
                  className="btn btn-sm btn-link p-0"
                  onClick={() => onOpenGuest(g._id)}
                  title="Edit forms"
                >
                  <FontAwesomeIcon icon={faClipboardList} />
                </button>
              </div>
            </div>
          ))}
        </>
      )}
      </div>
    </div>
  );
};

export default ParticipantGuestRow;
